import {
  titleUI,
  descriptionUI,
  descriptionSchema,
  yesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';

import fullSchema from '../../schema';
import ConfirmationHousingSituation from '../../components/confirmationFields/ConfirmationHousingSituation';
import { HousingSituationHelpDetails } from '../../components/VeteranDetails/housingSituation';

// Section I homelessness checkbox. On the paper form, checking this directs the
// Veteran to VA Form 20-10207. Online we capture the indicator (to set a
// priority-processing flash) and point to the same form. No follow-up questions.
export default {
  uiSchema: {
    'ui:confirmationField': ConfirmationHousingSituation,
    ...titleUI('Your housing situation'),
    ...descriptionUI(
      'If you’re homeless or at risk of becoming homeless, we’ll automatically process your claim as a priority.',
    ),
    isCurrentlyHomelessOrIsAtRiskOfBecomingHomeless: yesNoUI({
      title: 'Are you homeless or at risk of becoming homeless?',
      errorMessages: { required: 'Select a response' },
    }),
    'view:getHousingSituationHelp': descriptionUI(HousingSituationHelpDetails),
  },
  schema: {
    type: 'object',
    required: ['isCurrentlyHomelessOrIsAtRiskOfBecomingHomeless'],
    properties: {
      isCurrentlyHomelessOrIsAtRiskOfBecomingHomeless:
        fullSchema.properties.isCurrentlyHomelessOrIsAtRiskOfBecomingHomeless,
      'view:getHousingSituationHelp': descriptionSchema,
    },
  },
};
